// core version + navigation, pagination modules:
import Swiper, { Autoplay } from "swiper";

// configure Swiper to use modules
Swiper.use([Autoplay]);

(function () {
  const logoSlider = document.querySelectorAll(".logo-slider");
  let logoSwiper = [];

  for (let i = 0; i < logoSlider.length; i++) {
    logoSwiper[i] = new Swiper(logoSlider[i], {
      slidesPerView: "auto",
      allowTouchMove: false,
      loop: true,
      spaceBetween: 0,
      speed: 3500,
      autoplay: {
        delay: 0,
      },
    });
  }
})();
